import { Form, type FormInstance } from 'ALIASED-antd';
import type { TRegistrationForm } from './TRegistrationForm';

export interface RegistrationFormInstance extends FormInstance<TRegistrationForm> {
  getFieldsValue: (() => TRegistrationForm) &
    (<K extends keyof TRegistrationForm, KArg extends K[] | true>(
      nameList: KArg
    ) => KArg extends true ? TRegistrationForm : Pick<TRegistrationForm, K>);
}

/** Must be called from a child component of the `<Form />` component is passed the
 * `form` prop from `useForm<TRegistrationForm>()`. */
export const useRegistrationFormInstance = () => {
  return Form.useFormInstance<TRegistrationForm>() as RegistrationFormInstance;
};
